import Provider from './inject-provider'

const preferDefault = m => (m && m.default) || m

export const wrapRootElement = preferDefault(Provider)
